module.exports = __webpack_public_path__ + "static/img/pic_bg@2x.3b080951.png";